export default __webpack_public_path__ + "static/media/Rockwell Automation.3e3d0e80.png";